import React from 'react';
import TimbradoForm from './TimbradoForm';

const NuevoTimbrado = () => {
    return <TimbradoForm mode="ADD" />;
};

export default NuevoTimbrado;
